export default function() {
  return [
    {
      panelContent: [
        {
          type: 'text',
          title: 'Suspended Animation',
          description:
            'In the midst of downtown Mumbai, amongst skyscrapers and imperial bungalows you will find an anachronism. A fresh water reservoir with temples surrounding it called Banganga, named after a local legend. Until few years ago it was clean enough to host music festivals with a stage floating atop the water, helped by the acoustics of the temples around it. I attended one such event with tabla Maestro Zakir Hussain.It was magical.'
        },
        {
          type: 'image',
          url: 'photographs/SUSPENDED_ANIMATION/0.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/SUSPENDED_ANIMATION/1.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/SUSPENDED_ANIMATION/2.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/SUSPENDED_ANIMATION/3.jpg',
          size: 'landscape'
        },
        {
          type: 'text',
          title: 'Suspended Animation',
          description:
            'These days you will find adventurous teenagers summersaulting into questionable water. Captured here is one in mid-dive.'
        },
        {
          type: 'image',
          url: 'photographs/SUSPENDED_ANIMATION/4.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/SUSPENDED_ANIMATION/5.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/SUSPENDED_ANIMATION/6.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/SUSPENDED_ANIMATION/7.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/SUSPENDED_ANIMATION/8.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/SUSPENDED_ANIMATION/9.jpg',
          size: 'landscape'
        }
      ]
    },
    {
      panelContent: [
        {
          type: 'image',
          url: 'photographs/CIRCADIAN_RHYTHMS/0.jpg',
          size: 'landscape'
        },
        {
          type: 'text',
          title: 'Circadian Rhythms',
          description:
            "How does a city that never sleeps wake up? This series explores the graveyard shift; a subculture of invisible systems and rituals unique but not exclusive to Mumbai. Flowers, meat, newspapers and produce go through daily cycles of distribution that occur in the darkness of dawn. These circadian rhythms are fascinating in their use of the cities infrastructure and interstitial spaces for spreading across their activities. Newspaper distributers use pavements along closed shop fronts, railway stations become hubs for circulation, slaughter houses use underside of highways, all utilize the sleeping cities' otherwise bustling transit networks."
        },
        {
          type: 'image',
          url: 'photographs/CIRCADIAN_RHYTHMS/1.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/CIRCADIAN_RHYTHMS/2.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/CIRCADIAN_RHYTHMS/3.jpg',
          size: 'landscape'
        },
        {
          type: 'text',
          title: 'how Mumbai gets its protein',
          description:
            "the butchers' day starts at 3am. Laborers unload live chicken and make their way to the slaughterhouse as feathers fill the streets of Crawford Market."
        },
        {
          type: 'image',
          url: 'photographs/CIRCADIAN_RHYTHMS/4.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/CIRCADIAN_RHYTHMS/5.jpg',
          size: 'landscape'
        },
        {
          type: 'text',
          title: 'Circadian Rhythms',
          description:
            'The cacophony of trade and the smells and chaos of commerce fills these spaces. Instant cities form, temporal for the wee hours of the day and invisible to most of us. These twilight photographs render them visible.'
        },
        {
          type: 'image',
          url: 'photographs/CIRCADIAN_RHYTHMS/6.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/CIRCADIAN_RHYTHMS/7.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/CIRCADIAN_RHYTHMS/8.jpg',
          size: 'landscape'
        },
        {
          type: 'text',
          title: 'the markets run on her blessings',
          description:
            'Walking around Dadar flower market before daybreak a wandering vision amongst the marigolds, at ease with the cacophony of trade. Captured here; a moment between two anonymous strangers, in this city of billions, tethered by the lens.'
        },
        {
          type: 'image',
          url: 'photographs/CIRCADIAN_RHYTHMS/9.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/CIRCADIAN_RHYTHMS/10.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/CIRCADIAN_RHYTHMS/11.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/CIRCADIAN_RHYTHMS/12.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/CIRCADIAN_RHYTHMS/13.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/CIRCADIAN_RHYTHMS/14.jpg',
          size: 'portrait'
        }
      ]
    },
    {
      panelContent: [
        {
          type: 'text',
          title: 'jaisalmer series',
          description:
            '"If you want to know how much darkness there is around you, you must sharpen your eyes, peering at the faint lights in the distance." - Italo Calvino, Invisible Cities.'
        },
        {
          type: 'image',
          url: 'photographs/JAISALMER_SERIES/0.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/JAISALMER_SERIES/1.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/JAISALMER_SERIES/2.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/JAISALMER_SERIES/3.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/JAISALMER_SERIES/4.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/JAISALMER_SERIES/5.jpg',
          size: 'portrait'
        }
      ]
    },
    {
      panelContent: [
        {
          type: 'image',
          url: 'photographs/POETRY_IN_METAL/0.jpg',
          size: 'landscape'
        },
        {
          type: 'text',
          title: 'Poetry in metal',
          description: ''
        },
        {
          type: 'image',
          url: 'photographs/POETRY_IN_METAL/1.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/POETRY_IN_METAL/2.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/POETRY_IN_METAL/3.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/POETRY_IN_METAL/4.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/POETRY_IN_METAL/5.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/POETRY_IN_METAL/6.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/POETRY_IN_METAL/7.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/POETRY_IN_METAL/8.jpg',
          size: 'portrait'
        }
      ]
    },
    {
      panelContent: [
        {
          type: 'text',
          title: 'Ship of Theseus.......',
          description:
            '"......does an object, which has had all its components replaced, remain fundamentally the same object?"\nThis is a rare photograph of India\'s first aircraft carrier - INS Vikrant. After serving for 40-something years in the naval fleet it was decommissioned in 1997. For a while it was being used as a museum and was eventually sold for scrap metal. This photograph was taken a few days before it was hacked at the ship breaking yards in Darukhana, Mumbai.'
        },
        {
          type: 'image',
          url: 'photographs/PORT_CITY/0.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/PORT_CITY/1.jpg',
          size: 'landscape'
        },
        {
          type: 'text',
          title: 'port city',
          description: "The sea is Mumbai's compass. Above terracotta tiled roofscapes you get glimpses of the port."
        },
        {
          type: 'image',
          url: 'photographs/PORT_CITY/2.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/PORT_CITY/3.jpg',
          size: 'landscape'
        }
      ]
    },
    {
      panelContent: [
        {
          type: 'image',
          url: 'photographs/PORTRAITS/0.jpg',
          size: 'portrait'
        },
        {
          type: 'text',
          title: 'Nasra',
          description: ''
        },
        {
          type: 'image',
          url: 'photographs/PORTRAITS/1.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/PORTRAITS/2.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/PORTRAITS/3.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/PORTRAITS/4.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/PORTRAITS/5.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/PORTRAITS/6.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/PORTRAITS/7.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/PORTRAITS/8.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/PORTRAITS/9.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/PORTRAITS/10.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/PORTRAITS/11.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/PORTRAITS/12.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/PORTRAITS/13.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/PORTRAITS/14.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/PORTRAITS/15.jpg',
          size: 'portrait'
        }
      ]
    },
    {
      panelContent: [
        {
          type: 'text',
          title: 'textures',
          description: ''
        },
        {
          type: 'image',
          url: 'photographs/AHMEDABAD/0.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/AHMEDABAD/1.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/AHMEDABAD/2.jpg',
          size: 'landscape'
        },
        {
          type: 'image',
          url: 'photographs/AHMEDABAD/3.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/AHMEDABAD/4.jpg',
          size: 'portrait'
        },
        {
          type: 'image',
          url: 'photographs/AHMEDABAD/5.jpg',
          size: 'landscape'
        }
      ]
    }
  ];
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_panels.js